
import React from 'react';
import { Button } from "@/components/ui/button";
import { DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface DeleteContactDialogProps {
  isMobile: boolean;
  onDeleteContact: () => void;
}

const DeleteContactDialog: React.FC<DeleteContactDialogProps> = ({ 
  isMobile, 
  onDeleteContact 
}) => {
  return (
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>Delete Contact</DialogTitle>
        <DialogDescription>
          Are you sure you want to delete this contact? This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline">Cancel</Button>
        </DialogClose>
        <Button 
          variant="destructive" 
          onClick={onDeleteContact}
        >
          Delete Contact
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};

export default DeleteContactDialog;
